import { CalendarDays } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { EVENT_TYPE_LABELS, eventsOfDay, todayIso } from '@/lib/hoje'
import { calendarService } from '@/services/calendar-service'
import type { CalendarItem } from '@/types/calendar'
import { EmptyLine, HojeSection } from './HojeSection'
import { useHojeLoader } from './useHojeLoader'

function timeLabel(item: CalendarItem): string {
  if (item.allDay || !item.startTime) return 'Dia todo'
  return item.endTime ? `${item.startTime.slice(0, 5)}–${item.endTime.slice(0, 5)}` : item.startTime.slice(0, 5)
}

/** Audiências e compromissos de hoje (agenda do escritório). */
export function HojeAgenda() {
  const today = todayIso()
  const state = useHojeLoader(
    () => calendarService.getDailyView(today, { itemTypes: ['event'] }).then((d) => eventsOfDay(d.items)),
    today
  )

  return (
    <HojeSection title="Agenda de hoje" description="Audiências e compromissos" icon={CalendarDays} href="/calendar" state={state}>
      {(events) =>
        events.length === 0 ? (
          <EmptyLine>Nenhum compromisso hoje.</EmptyLine>
        ) : (
          <ul className="flex flex-col divide-y">
            {events.map((e) => (
              <li key={e.id} className="grid grid-cols-[5.5rem_1fr] items-start gap-2 py-2 text-sm">
                <span className="tabular-nums text-muted-foreground">{timeLabel(e)}</span>
                <span className="min-w-0">
                  <span className="flex flex-wrap items-center gap-1.5">
                    <span className="font-medium">{e.title}</span>
                    {e.eventType && (
                      <Badge variant={e.eventType === 'AUDIENCIA' ? 'default' : 'secondary'}>{EVENT_TYPE_LABELS[e.eventType]}</Badge>
                    )}
                  </span>
                  {(e.caseNumber || e.clientName) && (
                    <span className="block truncate text-xs text-muted-foreground">
                      {[e.caseNumber, e.clientName].filter(Boolean).join(' · ')}
                    </span>
                  )}
                </span>
              </li>
            ))}
          </ul>
        )
      }
    </HojeSection>
  )
}
